var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"storeContent"},[(_vm.storeStatus == 1)?_c('many-store'):_vm._e(),(_vm.storeStatus == 3 || _vm.storeStatus == 2)?_c('single-join',{attrs:{"storeId":_vm.storeId}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }